var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var CookieLawService = (function () {
    function CookieLawService() {
    }
    CookieLawService.prototype.seen = function (cookieName) {
        if (cookieName === void 0) { cookieName = 'cookieLawSeen'; }
        return this.cookieExisits(cookieName);
    };
    CookieLawService.prototype.storeCookie = function (cookieName, expiration) {
        return this.setCookie(cookieName, expiration);
    };
    CookieLawService.prototype.cookieExisits = function (name) {
        var ca = document.cookie.split(';');
        var caLen = ca.length;
        var cookieName = name + '=';
        var c;
        for (var i = 0; i < caLen; i += 1) {
            c = ca[i].replace(/^\s\+/g, '');
            if (c.indexOf(cookieName) !== -1) {
                return true;
            }
        }
        return false;
    };
    CookieLawService.prototype.setCookie = function (name, expiration) {
        var date = new Date();
        var expires;
        date.setTime(date.getTime() + expiration * 86400000);
        expires = '; expires=' + date.toUTCString();
        document.cookie = encodeURIComponent(name) + '=true; path=/' + expires;
    };
    return CookieLawService;
}());
CookieLawService = __decorate([
    Injectable()
], CookieLawService);
export { CookieLawService };
//# sourceMappingURL=cookie-law.service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-cookie-law/lib/cookie-law.service.js
// module id = 102
// module chunks = 3